module.exports = __webpack_public_path__ + "images/arrow_down@3x.png?53bee69f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow_down@3x.png
// module id = 596
// module chunks = 7